<div class="container pt-3">
  <rbb-side-menu-headline description="Hier werden alle Formulare angezeigt, die aktuell zur Verfügung stehen." headline="Alle Formulare" icon="fas fa-file-alt"/>

  @if (employee?.creator) {
    <div class="row mb-4">
      <div class="col">
        <a class="btn btn-sm btn-primary fw-bold" routerLink="/editor/new">Neues Formular erstellen</a>
      </div>
    </div>
  }

  <div class="small text-center text-secondary mb-4">
    Hier finden Sie alle Formulare, die in rbb Forms zur Verfügung stehen. Weitere Formulare finden Sie im
    <a href="https://rbb.sharepoint.com/sites/Intranet-Formulare" target="_blank" class="d-dmz-none">Intranet</a>
    <span class="d-none d-dmz-inline">Intranet</span>
    .
  </div>

  <div class="input-group input-group-sm mb-3">
    <label class="input-group-text" for="search"><i class="fas fa-search" aria-hidden="true"></i></label>
    <input id="search" name="search" type="text" class="form-control" placeholder="Nach Formular suchen" aria-label="Nach Formular suchen" [(ngModel)]="search">
  </div>


  @if (categories && forms) {
    <div class="row">
      <div class="col-md-4" [ngClass]="{'border-right': width > 767}">
        <div class="mb-4">
          <h4 class="text-primary">Kategorien</h4>

          <div class="list-group list-group-flush button-adde  p-1 pt-0 border-none">
            @if (categories) {
              @if (search.length >= 2) {
                <a class="list-group-item active">
                  <div>
                    <i class="fas fa-search"></i>
                    <span class="ps-2">Suchergebnis</span>
                  </div>
                </a>
              }
              @for (cat of categories; track cat) {
                <a (click)="selectCategory(cat);"
                   (keydown.enter)="selectCategory(cat);"
                   (keydown.space)="selectCategory(cat);"
                   tabindex="0"
                   [ngClass]="{'active' : selectedCategory && selectedCategory === cat && search.length < 2}"
                   class="list-group-item list-group-item-action pointer">
                  <div>
                    @if (selectedCategory && selectedCategory === cat && search.length < 2) {
                      <i class="far fa-folder-open"></i>
                    } @else {
                      <i class="far fa-folder"></i>
                    }
                    <span class="ps-2">{{cat}}</span>
                  </div>
                </a>
              }
            } @else {
              <div class="text-center mt-5">
                <rbb-loader/>
              </div>
            }
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <h4 class="text-primary">
          @if (search.length < 2) {
            Formulare: {{selectedCategory}}
          } @else {
            Suchergebnis: {{search.trim()}}
          }
        </h4>
        <ul class="list-group list-group-flush no-marker">
          @for (form of (forms | formsSearch:selectedCategory:search); track form.id) {
            <li>
              <a class="list-group-item list-group-item-action nav-link no-border" routerLink="/{{form.group ? 'group' : 'form'}}/{{form.id}}">
                <i class="far" [class.fa-file-alt]="!form.group" [class.fa-clone]="form.group"></i>&ensp;{{form.name}}&ensp;
                @if (isProductive(form)) {
                  <span class="badge bg-primary"><small>PROD</small></span>
                }
                @if (form.test) {
                  <span class="badge bg-warning"><small>TEST</small></span>
                }
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
  } @else {
    <div class="text-center m-auto mt-5">
      <rbb-loader/>
      <small class="text-secondary d-block">Formulare werden geladen...</small>
    </div>
  }
</div>

